'use strict';

angular.module('layout.tag.resources', [])
    .factory('LayoutTagsResource', LayoutTagsResource)
    .factory('LayoutTagsDataGridFactory', LayoutTagsDataGridFactory);

/**
 * @ngInject
 */
function LayoutTagsResource(
    Restangular
) {
    var resource = Restangular.all('layouttags');

    return {
        save: save,
        getData: getData
    };

    /**
     *
     * Save list of new tags
     * @param tags
     * @returns {*|{method}|{method, isArray}}
     */
    function save(tags) {
        var payload = _.map(tags, function (tag) {
            return {text: tag};
        });
        return resource.all('tagList').post(payload).then(function (json) {
            return json.plain();
        });
    }

    /**
     * @param queryParams
     * @returns {angular.IPromise<any>}
     */
    function getData(queryParams) {
        queryParams = _.assign({
            all: true
        }, queryParams);
        return resource.getList(queryParams).then(function (json) {
            return json.plain();
        });
    }
}

/**
 * @ngInject
 */
function LayoutTagsDataGridFactory(
    LibraryTagColumns,
    DataGridRender
) {
    return {
        getDTOptions: getDTOptions,
    };

    /**
     * Return manage layouts datatable options
     * @returns {{}}
     */
    function getDTOptions() {

        var dtOptions = {};
        dtOptions.customRenders = {};
        dtOptions.numActions = 1;
        dtOptions.customRenders[LibraryTagColumns.ID] = function (data, type, full) {
            return DataGridRender.getDeleteButton(full.can_be_deleted, 'layouttags/' + data, full['text']);
        };

        return dtOptions;
    }
}